import { World } from "ecsy";
import { TimeContext } from "./Context/TimeContext";

export const update = (world: World, timeContext: TimeContext) => {
  world.execute(
    timeContext.deltaTime,
    timeContext.currTime - timeContext.startTime
  );
};
